import {
  AgrLoginTypes,
  IETFLocales,
  setAgrEnvironment,
  SignupSigninPolicy,
} from '@next/core-lib/environment';

import { Environment } from './environment.model';

export { Environment } from './environment.model';

export const environment: Environment = {
  ...setAgrEnvironment({
    APPLICATION_NAME: 'Graanaanmelden',
    API_BASE_URL: 'https://grain-registration.agrifirm.com',
    APIM_BASE_URL: 'https://gateway.api.agrifirm.com/external',
    API_BASE_HREF: '/',
    CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
    REDIRECT_URL: 'https://grain-registration.agrifirm.com',
    LOGIN_TYPE: AgrLoginTypes.redirect,
    SIGNUP_SIGNIN_POLICY: SignupSigninPolicy.All,
    PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
    AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
    APPLICATION_KEY: 'Aanmelden',
    APP_INSIGHTS_KEY: '',
    DEFAULT_LOCALE: IETFLocales.nl,
    LOCALES: `${IETFLocales.nl},${IETFLocales.en}`,
    PRODUCTION: 'true',
    RELATIONSHIPS_ELASTIC_SEARCH: 'true',
  }),
};
